import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getInventorySummary = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/inventory/summary`, { ...withAuth(), params })).data;

export const getInventoryMovements = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/inventory/movements`, { ...withAuth(), params })).data;

export const getInventoryEmailSuggestions = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/inventory/email-suggestions`, { ...withAuth(), params })).data;

export const sendInventoryEmail = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/inventory/email`, data, withAuth())).data;

export const getInventoryCountSessions = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/inventory/counts`, { ...withAuth(), params })).data;

export const getInventoryCountSession = async (branchId, countId) =>
  (await axios.get(`${API_URL}/branch/${branchId}/inventory/counts/${countId}`, withAuth())).data;

export const createInventoryCount = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/inventory/counts`, data, withAuth())).data;

export const updateInventoryCount = async (branchId, countId, data) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/inventory/counts/${countId}`, data, withAuth())).data;

export const finalizeInventoryCount = async (branchId, countId) =>
  (await axios.post(`${API_URL}/branch/${branchId}/inventory/counts/${countId}/finalize`, {}, withAuth())).data;

export const createInventoryMerma = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/inventory/mermas`, data, withAuth())).data;
